<template>
  <div class="flex flex-col container mx-auto mt-3 px-4 py-4">
      <div class="block pl-8">
        <h1 class="md:text-4xl text-2xl font-bold font-sans m-0 leading-none">
         fs-identity
        </h1>
        <p class="text-lg w-full my-6 pr-48">
         fs identity ett verktyg för att administrera användare, roller och Identity resurser.
        </p>
      </div>
 </div>
</template>

<script>
export default {
  name: "startpage"
};
</script>
